import { render } from "./ProductRangeItem.vue?vue&type=template&id=1126a7cd&scoped=true"
import script from "./ProductRangeItem.vue?vue&type=script&lang=js"
export * from "./ProductRangeItem.vue?vue&type=script&lang=js"

import "./ProductRangeItem.vue?vue&type=style&index=0&id=1126a7cd&scoped=true&lang=scss"

import exportComponent from "/Users/skynet/Documents/Sites Safe OK MAIS PEUT ETRE PAS A JOUR/Safe_Sites_Modifs/SAFE_ORTHO/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1126a7cd"]])

export default __exports__